module.exports = __webpack_public_path__ + "static/img/onboarding_checkout_modal.16d83aa5.png";